import compact from 'lodash/compact';

// eslint-disable-next-line import/prefer-default-export
export function fullName(contact) {
  return compact([contact.firstName, contact.lastName]).join(' ');
}
